import { Box, Grid, Paper, Typography } from "@mui/material";
import React from "react";

const SingleDayAttendanceCards = ({ data }) => {
  return (
    <Box mb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <Paper
            elevation={4}
            sx={{
              boxShadow: "none",
              background: "linear-gradient(125deg, #51475bff, #792191ff)",
              color: "#fff",
              minHeight: 90,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                letterSpacing: 1,
                opacity: 1,
              }}
            >
              Total
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                mt: 0.5,
              }}
            >
              {data?.total}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Paper
              elevation={4}
              sx={{
                boxShadow:'none',
                background: "linear-gradient(125deg, #51475bff, #792191ff)",
                color: "#fff",
                minHeight: 90,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
 
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  letterSpacing: 1,
                  opacity:1,
                }}
              >
               Present
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  mt: 0.5,
                }}
              >
                {data?.present}
              </Typography>
            </Paper>
          </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <Paper
            elevation={4}
            sx={{
              boxShadow: "none",
              background: "linear-gradient(125deg, #51475bff, #792191ff)",
              color: "#fff",
              minHeight: 90,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                letterSpacing: 1,
                opacity: 1,
              }}
            >
              Absent
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                mt: 0.5,
              }}
            >
              {data?.absent}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SingleDayAttendanceCards;
